<template>
	<scoped-overflow-layout :loading="!isReady">
		<template #toolbar>
			<v-toolbar flat dense color="white">
				<bar-nav-back @navBack="navBack" />
			</v-toolbar>
		</template>

		<v-container fluid>
			<v-layout>
				<v-flex xs12 sm12 lg8 offset-lg2 xl6 offset-xl3>
					<v-card>
						<comment-list
							:actionID="id"
							:comments="comments"
							:maxVisibleComments="0"
							:maxInlineComments="0" />
					</v-card>
				</v-flex>
			</v-layout>
		</v-container>
	</scoped-overflow-layout>
</template>


<script>
import ScopedOverflowLayout from "@/layouts/ScopedOverflowLayout.vue";
import BarNavBack from "@/components/BarNavBack.vue";
import CommentList from '@/components/CommentList';

export default {
	name: "action-comments",
	components: { ScopedOverflowLayout, BarNavBack, CommentList },
	props: {
		id: Number,
	},
	data() { return {
		isReady: false,
	}},
	computed: {
		comments() {
			return this.$store.getters['comments/byAction'](this.id);
		},
	},
	methods: {
		async fetchData() {
			this.isReady = false;
			await this.$store.dispatch('comments/fetchByActionID', this.id);
			this.isReady = true;
		},
		navBack() {
			this.$router.go(-1);
		},
	},
	created() {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData',
	},
};
</script>
